export default __webpack_public_path__ + "static/media/cleaning products_cat_disabled.b5277384.png";